/**
 * Форматирует hierarchy зон согласно следующим правилам:
 * - 1 зона: полное имя
 * - 2 зоны: первая - 1 символ, вторая - полностью
 * - 3+ зоны: первая - 1 символ, вторая - последние 2 символа, остальные - полностью
 *
 * @param hierarchy - строка вида "id1.id2.id3" с идентификаторами зон
 * @param getZoneTitle - функция для получения названия зоны по её id
 * @returns массив с названиями зон
 */
export function formatZoneHierarchy(hierarchy: string, getZoneTitle: (zoneId: string) => string | undefined) {
  if (!hierarchy) return [];

  const zoneIds = hierarchy.split(".");
  const count = zoneIds.length;

  if (count === 0) return [];

  const formattedTitles = zoneIds.map((id, index) => {
    const title = getZoneTitle(id);

    if (!title) return "";
    if (count === 1 || count === 2) return title;
    if (count >= 3) {
      if (index === 0) return title[0];
      if (index === 1) return title.slice(-2);
    }

    return title;
  });

  return formattedTitles.filter(Boolean);
}
